import { useQuery } from '@tanstack/react-query'
import { zetApi } from '@zet/network'
import { FIVE_MINUTES } from '@zet/utils/cacheTime'
import storageUtil from '@zet/utils/storage'

import { getExperiments } from '../function'
import { getExperimentsFallBackData } from '../utils'

const useExperiments = (isEnabled = true) => {
  return useQuery(['experiments'], getExperiments, {
    refetchOnWindowFocus: false,
    //! This time frame added if user is refereshing the page
    staleTime: storageUtil.getObject('experiments') ? FIVE_MINUTES : 0,
    cacheTime: FIVE_MINUTES,
    enabled:
      (!!zetApi.defaults.headers.common.Authorization ||
        !!zetApi.defaults.headers.common?.hash) &&
      isEnabled,
    placeholderData: getExperimentsFallBackData(),
  })
}

export { useExperiments }
